import { useEffect, useState } from "react";
import "../SendOTP/SendOTP.scss";
import { useNavigate } from "react-router-dom";
import "../Login/Login.scss";
import Auth_OTP_Logo from "../../assets/images/logo/otp-logo.svg";
import EditIcon from "../../assets/images/vactor/edit-icon.svg";
import { PrimaryButton } from "../../components/AllButtons/AllButtons";
import TitleComponent from "../../components/CommonElements/TitleComponent/TitleComponent";
import { setOtp } from "../../Slice/credentialSlice";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { openSnackbar } from "../../Slice/snackbarSlice";
import { sendForgotPasswordRequest } from "../../Services/auth.service";


const SendOTP = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const storedEmail = useAppSelector(state => state.credentials.email);
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const confirmOtp = useAppSelector(state => state.credentials.confirmOtp);
  const [timeLeft, setTimeLeft] = useState(120);
  const [isResendVisible, setIsResendVisible] = useState(false);


  useEffect(() => {
    if (timeLeft <= 0) {
      setIsResendVisible(true)
      return;
    }

    const timerId = setInterval(() => {
      setTimeLeft(prevTime => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);


  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  const handleChange = (index: number, value: string) => {

    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otpValues];
    newOtp[index] = value;
    setOtpValues(newOtp);


    if (value !== "" && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };


  const handleKeyDown = (index: number, event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Backspace" && otpValues[index] === "" && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }
  };


  const isOtpComplete = otpValues.every((digit) => digit !== "");



  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isOtpComplete) return;
    const enteredOtp = otpValues.join("");
    if (enteredOtp !== confirmOtp) {
      dispatch(openSnackbar({ message: "Enter correct OTP", severity: "error" }));
      return;
    }


    dispatch(setOtp(enteredOtp));
    navigate("/reset_password");
  };

  const handleResendOTP = () => {
    setTimeLeft(120);
    setIsResendVisible(false);
    const emailObj = { email : storedEmail };
    dispatch(sendForgotPasswordRequest(emailObj)).unwrap().then((response : any) => { 
      if (response.status) {
        dispatch(openSnackbar({ message: response.message, severity: "success" }));
      } else {
        dispatch(openSnackbar({ message: response.message, severity: "error" }));
      }
    }).catch((error) => console.error("Something went wrong ", error));

  };
return (
  <>
    <div className="auth-wrapper">
      <div className="row mx-0 h-100">
        <TitleComponent />
        <div className="col-md-12 col-lg-5 col-xl-4 p-0">
          <div className="auth-form-block">
            <div className="auth-form-content-block">
              <div className="auth-logo">
                <img src={Auth_OTP_Logo} alt="OTP Logo" />
              </div>
              <p className="banner-content-title">Forgot Your Password?</p>
              <p className="content-dsc-text">
                No worries! Enter your email, and we'll send you a 6-digit OTP.
              </p>

              <form onSubmit={handleSubmit} className="w-100">
                <div className="otp-input-form-field">
                  {otpValues.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      className="otp-input"
                      type="text"
                      value={digit}
                      maxLength={1}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      inputMode="numeric"
                      pattern="[0-9]*"
                    />
                  ))}
                </div>

                <div className="auth-action-control">
                  <PrimaryButton
                    type="submit"
                    disabled={!isOtpComplete}
                    style={{
                      backgroundColor: isOtpComplete ? "#4F46E5" : "#505050",
                      color: "#fff",
                      cursor: isOtpComplete ? "pointer" : "not-allowed",
                    }}
                  >
                    Reset Now
                  </PrimaryButton>
                </div>

                <div className="auth-info-text">
                  {storedEmail || "test@gmail.com"}
                  <div className="auth-link" onClick={() => navigate('/forgot_password')} style={{ cursor: "pointer" }}>
  <img src={EditIcon} alt="Edit" />
</div>

                </div>
              </form>

              <div className="resend-timer" style = {{display : !isResendVisible ? "block" : "none"}}>Resend in : <span className="time-couter">{formattedTime}</span> </div>  
              <div className="resend-otp-btn-block">
              <button style={{ display: isResendVisible ? "block" : "none" }} onClick={() => handleResendOTP()} className="resend-otp-btn">Resend OTP</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);
};

export default SendOTP;
